import { excludeProps, GridCol, Icon, mixins, styled } from '@bob/library'
import { Asset } from '@websrc/App/Components/Asset/Asset'
import { ComponentPropsWithoutRef } from 'react'

import { SpotLinkAnchor } from '../Link/SpotLinkAnchor'
import { SpotLinkButton } from '../Link/SpotLinkButton'

export const StyledGridCol = styled(GridCol)`
  ${mixins.margin.bottom(20)}
`

export interface ItemWrapperProps extends ComponentPropsWithoutRef<'a'> {
  url?: string
}

export const ItemBackgroundImageWrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -1;

  > div {
    height: 100%;

    &:before {
      content: '';
      background: rgba(0, 0, 0, 0.5);
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }

    > img {
      height: 100%;
      object-fit: cover;
    }
  }
`

export const ItemWrapper = styled(excludeProps(SpotLinkAnchor, 'url'))<ItemWrapperProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: ${({ url }) => (url ? `transparent` : mixins.colors.grayLight)};
  background-blend-mode: multiply;
  background-size: 100%;
  background-size: cover;
  ${mixins.padding(100, 50)}
  ${mixins.media.max.phone} {
    ${mixins.padding(100, 10)}
  }
  position: relative;
`

export type TitleProps = {
  hasBackground: boolean
}

export const StyledButton = styled(excludeProps(SpotLinkButton, 'hasBackground'))<TitleProps>`
  ${({ hasBackground }) => mixins.cta.tertiary(hasBackground ? 'white' : 'blue')};
`

export const Title = styled.h1<TitleProps>`
  ${mixins.typography.noColor.headlineMedium}
  color: ${({ hasBackground }) =>
    hasBackground ? mixins.colors.grayWhite : mixins.colors.grayBlack};
  text-align: center;
  max-width: 600px;
  ${mixins.margin.top(0)}
  ${mixins.margin.bottom(30)}
`

export const StyledIcon = styled(Icon)`
  ${mixins.margin.bottom(20)}
`

export const ProductImage = styled(Asset)`
  ${mixins.margin.top(15)}
  width: 60%;
`
export const LearnMoreButtonWrapper = styled.div`
  ${mixins.margin(30)}
`
